import './DeleteButton.css'

import { Close as CloseIcon } from "@mui/icons-material";
import classNames from 'classnames';
import PropTypes from "prop-types";
import React from "react";

import ConfirmedButton from "./ConfirmedButton.js";

const DeleteButton = ({ onDelete, className, classNameInner, positionRight }) => {
    return (
        <ConfirmedButton
            classNameInner={classNames(classNameInner, "delete-btn-confirm")}
            className={classNames(className, "delete-btn", {"delete-btn-right": positionRight})}
            confirmText="Deseja mesmo apagar este conteúdo?"
            confirmTitle="Apagar"
            onClick={onDelete}
        >
            <CloseIcon/>
        </ConfirmedButton>
    )
}

DeleteButton.propTypes = {
    onDelete: PropTypes.func.isRequired
};

export default DeleteButton;